<template>
  <div class="detailsTitle">
    <div class="detailsTitleBox">
      <div class="info">
        <div class="info-title">
          <div class="discount" v-if="productInfo.IsCouponProduct">
            {{ $t.shopping.isCoupon }}
          </div>
          <div class="brand" v-if="productInfo.IsBrandProduct">
            {{ $t.shopping.isBrand }}
          </div>
          <div class="attestation" v-if="productInfo.IsAttestationProduct">
            {{ $t.shopping.isAttestation }}
          </div>
          <span class="name">{{ productInfo.ProductName }}</span>
        </div>
      </div>
      <div class="priceBox">
        <span class="unit">$</span>{{ Math.round(productInfo.MinPrice * 100) / 100 }}
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { isAPP, getPlatform } from "@/plugins/environment/type.js";

export default {
  name: "DetailsTitle",
  props: ["productInfo"],
  data() {
    return {
      isApp: isAPP(),
      platform: getPlatform(),
    };
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.detailsTitle {
  width: 100%;
  margin-top: 10px;
  .detailsTitleBox {
    margin: 0 auto;
    position: relative;
    min-height: 90px;
    box-shadow: 0px 2.5px 5px 0px rgba(0, 0, 0, 0.3);
    padding: 12px 22px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    border-radius: 8px;
    width: 92%;
    .info {
      margin-top: 5px;
      @include publicFlex;
      .info-title {
        flex: 1;
        -webkit-flex: 1;
        font-size: 15px;
        color: #000000;
        .discount {
          vertical-align: middle;
          display: inline-block;
          background: red;
          color: white;
          padding: 0px 2px;
          border-radius: 2px;
          font-size: 12px;
          margin-right: 5px;
        }
        .brand {
          vertical-align: middle;
          display: inline-block;
          background: #e6a23c;
          color: white;
          padding: 0px 2px;
          border-radius: 2px;
          font-size: 12px;
          margin-right: 5px;
        }
        .attestation {
          vertical-align: middle;
          display: inline-block;
          background: #22b196;
          color: white;
          padding: 0px 2px;
          border-radius: 2px;
          font-size: 12px;
          margin-right: 5px;
        }
        .name {
          vertical-align: middle;
          display: inline-block;
        }
      }
    }
    .priceBox {
      width: 100%;
      font-size: 15px;
      font-weight: bold;
      color: #ff5852;
      margin-top: 9px;
      .unit {
        margin-right: 3.5px;
      }
    }
  }
}
</style>
